import { useRef } from 'react';
import { symbolToken } from '@servicetitan/react-ioc';
export const BASENAME_TOKEN = symbolToken('BASENAME_TOKEN');
export const EXPOSED_DEPENDENCIES_TOKEN = symbolToken('EXPOSED_DEPENDENCIES_TOKEN');
export const EXPOSED_INSTANCE_DEPENDENCIES_TOKEN = symbolToken('EXPOSED_INSTANCE_DEPENDENCIES_TOKEN');
export const IS_WEB_COMPONENT_TOKEN = symbolToken('IS_WEB_COMPONENT_TOKEN');
export const RENDER_ROOT_TOKEN = symbolToken('RENDER_ROOT_TOKEN');
export async function getJson(url, { retries = 5, retryDelay = 1000, onRequestError, ...config } = {}) {
    var _a, _b;
    let response;
    try {
        response = await fetch(url, config);
    }
    catch (_c) {
        if (retries > 0 && !((_a = config.signal) === null || _a === void 0 ? void 0 : _a.aborted)) {
            return new Promise((resolve, reject) => {
                const { signal } = config;
                const timeoutId = window.setTimeout(() => {
                    getJson(url, {
                        ...config,
                        onRequestError,
                        retries: retries - 1,
                        retryDelay: retryDelay * 4,
                    }).then(resolve, reject);
                }, retryDelay);
                const abortHandler = () => {
                    window.clearTimeout(timeoutId);
                    signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abortHandler);
                    reject(signal === null || signal === void 0 ? void 0 : signal.reason);
                };
                signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', abortHandler);
            });
        }
        throw new Error(`Failed to fetch: "${url}".`);
    }
    const responseJSON = await response.json().catch(() => ({}));
    if (!response.ok) {
        let message = `Requesting "${url}" failed with status code ${response.status}.`;
        try {
            message += ` Details: ${await response.text()}.`;
        }
        catch (_d) { } // eslint-disable-line no-empty
        onRequestError === null || onRequestError === void 0 ? void 0 : onRequestError({
            status: response.status,
            json: responseJSON,
            body: await response.text().catch(() => ''),
        });
        throw new Error(message);
    }
    return { data: responseJSON, headers: response.headers, url: (_b = response.url) !== null && _b !== void 0 ? _b : url };
}
export function useCancelation() {
    return useRef(new AbortController()).current;
}
//# sourceMappingURL=common.js.map